<template>
    <edit></edit>
</template>

<script>
    import edit from './recharge_bonus_edit.vue'

    export default {
        name: 'recharge_bonus_add',

        components: {
            edit
        }
    }
</script>